module.exports = __webpack_public_path__ + "assets/cross.4f60f070.svg";